import { render, staticRenderFns } from "./topCom.vue?vue&type=template&id=3bd2eb64&scoped=true&"
import script from "./topCom.vue?vue&type=script&lang=ts&"
export * from "./topCom.vue?vue&type=script&lang=ts&"
import style0 from "./topCom.vue?vue&type=style&index=0&id=3bd2eb64&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd2eb64",
  null
  
)

export default component.exports